"use strict";

exports.__esModule = true;
exports.colors = colors;
exports.replacePalette = replacePalette;
exports.replaceParams = replaceParams;

var _colors = require("./colors.js");

var _utils = require("./utils.js");

function toUnitVector(n) {
  return Math.round(n / 255 * 1000) / 1000;
}

function fromUnitVector(n) {
  return Math.round(n * 255);
}

function toLottieColor(hex) {
  var _hexToRgb = (0, _colors.hexToRgb)(hex),
      r = _hexToRgb.r,
      g = _hexToRgb.g,
      b = _hexToRgb.b;

  return [toUnitVector(r), toUnitVector(g), toUnitVector(b)];
}

function fromLottieColor(r, g, b) {
  r = fromUnitVector(r);
  g = fromUnitVector(g);
  b = fromUnitVector(b);
  return (0, _colors.rgbToHex)({
    r: r,
    g: g,
    b: b
  });
}
/**
 * Extracts changeable fields. Supports lordicon.com namespace.
 * @param data
 */


function allChangeableFields(data) {
  var result = [];

  if (!data.layers) {
    return result;
  }

  for (var _i = 0, _Object$entries = Object.entries(data.layers); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
        layerIndex = _Object$entries$_i[0],
        layer = _Object$entries$_i[1];

    if (!layer.nm || !layer.nm.toLowerCase().includes('change')) {
      continue;
    }

    if (!layer.ef) {
      continue;
    }

    for (var _i2 = 0, _Object$entries2 = Object.entries(layer.ef); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = _Object$entries2[_i2],
          fieldIndex = _Object$entries2$_i[0],
          field = _Object$entries2$_i[1];
      var subpath = 'ef.0.v.k';
      var path = "layers." + layerIndex + ".ef." + fieldIndex + "." + subpath;
      var hasValue = (0, _utils.has)(field, subpath);

      if (!hasValue) {
        continue;
      }

      var type = 'unkown';

      if (field.mn === 'ADBE Color Control') {
        type = 'color';
      } else if (field.mn === 'ADBE Slider Control') {
        type = 'value';
      }

      if (type === 'unkown') {
        continue;
      }

      var value = (0, _utils.get)(field, subpath);
      result.push({
        path: path,
        value: value,
        type: type
      });
    }
  }

  return result;
}
/**
 * Extracts colors found in the animation in hex format.
 * @param data
 */


function colors(data) {
  return allChangeableFields(data).filter(function (c) {
    return c.type === 'color';
  }).map(function (c) {
    var _c$value = c.value,
        r = _c$value[0],
        g = _c$value[1],
        b = _c$value[2],
        a = _c$value[3];
    return fromLottieColor(r, g, b);
  });
}
/**
 * Update fields of type with provide value and callback.
 * @param data Animation data.
 * @param values Replacement values. Separate them with ";" symbol.
 */


function updateData(data, type, values, callback) {
  if (!data || !type || !values) {
    throw new TypeError('Missing parameters.');
  } // all params of type


  var params = allChangeableFields(data).filter(function (c) {
    return c.type === type;
  }); // new params values

  var newValues = Array.isArray(values) ? values : values.split(';').filter(function (c) {
    return c;
  });

  for (var _i3 = 0, _Object$entries3 = Object.entries(newValues); _i3 < _Object$entries3.length; _i3++) {
    var _Object$entries3$_i = _Object$entries3[_i3],
        index = _Object$entries3$_i[0],
        value = _Object$entries3$_i[1];
    var currentParam = params[index];

    if (!currentParam) {
      continue;
    }

    var newValue = callback(value, currentParam.value);
    (0, _utils.set)(data, currentParam.path, newValue);
  }

  return data;
}
/**
 * Replace colors in provided animation and returns new version of it.
 * @param data Animation data.
 * @param palette Color replacement details. Separate new colors with ";" symbol.
 */


function replacePalette(data, palette) {
  var callback = function callback(colorValue, previousLottieValue) {
    var or = previousLottieValue[0],
        og = previousLottieValue[1],
        ob = previousLottieValue[2],
        oa = previousLottieValue[3];
    return [].concat(toLottieColor(colorValue), [oa]);
  };

  return updateData(data, 'color', palette, callback);
}
/**
 * Replace params in provided animation and returns new version of it.
 * @param data Animation data.
 * @param params Params used by animation. Separate them with ";" symbol.
 */


function replaceParams(data, params) {
  var callback = function callback(paramValue) {
    return +paramValue;
  };

  return updateData(data, 'value', params, callback);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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